
import React from 'react';
import YouTubeAuthCallback from '@/components/youtube-auth/YouTubeAuthCallback';

const YouTubeAuthCallbackPage = () => {
  return <YouTubeAuthCallback />;
};

export default YouTubeAuthCallbackPage;
